import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { BackofficeJobNamesResultSchema } from "schema"
import { z } from "zod"

type BackofficeJobNamesResult = z.infer<typeof BackofficeJobNamesResultSchema>

export const getBackofficeJobNamesQuery = () =>
  queryOptions({
    queryKey: ["backofficeJobNames"],
    queryFn: async () => {
      const { data } = await axios.get<{ data: BackofficeJobNamesResult }>(
        "/backoffice/jobSearch/names",
      )
      return BackofficeJobNamesResultSchema.parse(data.data)
    },
  })
